<template>
  <div class="row page-wrapper">
    <div class="col-12">
      <div class="row page-header">
        <div class="col-12 col-md-6 col-xl-8">
          <h3>Lizenzen</h3>
        </div>
        <div class="col-12 col-md-6 col-xl-4">
          <b-button to="/add-license" class="btn-new-license btn-primary float-right">
            + Neue Lizenz erstellen
          </b-button>
        </div>
      </div>
      <div class="row table-wrapper">
        <!-- <div class="col-12">
          <data-table
            ref="table"
            v-model="table"
            id="license-table"
            :get-page="getPage"
            :per-page="1000"
            :selectable-rows="true"
            :has-details-row="false"
            :busy="isLoading"
            :responsive="true"
          >
            <template #head(ownerCompanyName)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.ownerCompanyName" input-type="text" />
            </template>
            <template #head(modules)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.modules" input-type="text" />
            </template>
            <template #head(ownerContactEmail)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.ownerContactEmail" input-type="text" />
            </template>
            <template v-slot:cell(validUntil)="data">
              {{ data.value | formatDate }}
            </template>
            <template v-slot:cell(issuedAt)="data">
              {{ data.value | formatDateTime }}
            </template>
            <template v-slot:cell(updatedAt)="data">
              {{ data.value | formatDateTime }}
            </template>
            <template v-slot:cell(modules)="data">
              {{ getModulesString(data.value) }}
            </template>
            <template v-slot:cell(actions)="data">
              <div class="btn-actions-container">
                <img svg-inline class="icon btn btn-actions" :src="exportIcon" @click="exportLicense(data.item.id)" />
                <img svg-inline class="icon btn btn-actions" :src="removeIcon" @click="confirmLicenseRemoval(data.item)" />
                <b-button size="sm" variant="outline-primary" @click="updateLicense(data.item)">
                  <b-icon icon="pencil" />
                </b-button>
              </div>
            </template>
            <template v-slot:table-busy>
              <div class="text-center">
                <b-spinner class="align-middle" />
                <strong>Loading...</strong>
              </div>
            </template>
          </data-table>
        </div> -->
        <div class="col-12 mb-4">
          <GridTable
            :get-page="getPage"
            :isLoading="isLoading"
            :columns="columns"
            :perPage="perPage"
            :currentPage="currentPage"
            :onDelete="confirmLicenseRemoval"
            :onExport="exportLicense"
            :onEdit="updateLicense"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import { NavigationMixin, LicenseMixin, AuthMixin } from '../../mixins';
import exportIcon from '../../assets/icons/export.svg';
import removeIcon from '../../assets/icons/remove.svg';
import warningIcon from '../../assets/icons/warning.svg';
import { BIcon, BIconPencil } from 'bootstrap-vue';
import GridTable from '../table/new-data-table';

import TableFilter from '../table/table-filter';
import DataTable from '../table/data-table';

export default {
  name: 'LicenseList',
  components: { BIcon, BIconPencil, TableFilter, DataTable, GridTable },
  mixins: [NavigationMixin, LicenseMixin, AuthMixin],
  data: function() {
    return {
      table: {
        fields: [
          { key: 'ownerCompanyName', label: 'Lizenznehmer' },
          // { key: 'ownerContactEmail', label: 'Kontaktperson' },
          { key: 'numberOfDevices', label: 'Geräteanzahl' },
          // { key: 'iPodCount', label: 'iPod' },
          // { key: 'iPadCount', label: 'iPad' },
          { key: 'modules', label: 'Modules' },
          // { key: 'version', label: 'Version' },
          // { key: 'issuedBy', label: 'Ausgestellt von' },
          { key: 'validUntil', label: 'Gültig bis' },
          { key: 'issuedAt', label: 'Ausstellungsdatum' },
          { key: 'updatedAt', label: 'Aktualisierungsdatum' },
          { key: 'actions', label: '', class: 'actions-cell' }
        ],
        filter: { ownerCompanyName: null, modules: null, ownerContactEmail: null },
        sortDesc: true,
        sortBy: 'createdAt'
      },
      columns: [
        { field: 'ownerCompanyName', title: 'Lizenznehmer' },
        // { field: 'ownerContactEmail', title: 'Kontaktperson' },
        { field: 'numberOfDevices', title: 'Geräteanzahl', filterable: false },
        // { field: 'iPodCount', title: 'iPod' },
        // { field: 'iPadCount', title: 'iPad' },
        { field: 'modules', title: 'Modules' },
        // { field: 'version', title: 'Version' },
        // { field: 'issuedBy', title: 'Ausgestellt von' },
        { field: 'validUntil', title: 'Gültig bis', filterable: false, cell: 'dateCell' },
        { field: 'issuedAt', title: 'Ausstellungsdatum', filterable: false, cell: 'dateCell' },
        { field: 'updatedAt', title: 'Aktualisierungsdatum', filterable: false, cell: 'dateCell' },
        { field: 'licenseStatus', title: 'Status', filterable: false, sortable: false },
        { field: 'actions', title: ' ', class: 'actions-cell', filterable: false, sortable: false, cell: 'actionCellTemplate' }
      ],
      exportIcon: exportIcon,
      removeIcon: removeIcon,
      isLoading: false,
      perPage: 1000,
      currentPage: 1,
      totalCount: null
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated
    })
  },
  methods: {
    ...mapActions({
      setSelectedLicense: 'license/setSelectedLicense'
    }),
    async getPage(ctx) {
      this.isLoading = true;
      const response = await this.licenseService.getLicenses(ctx);
      response.data = response.data.map(l => {
        let licenseStatus = 'Valid';
        if (moment(l.validUntil).diff(Date.now(), 'days') < 30) {
          licenseStatus = 'Expired soon';
        }
        if (moment(l.validUntil).diff(Date.now(), 'days') <= 0) {
          licenseStatus = 'Expired';
        }

        return {
          id: l.id,
          ownerCompanyName: l.ownerCompanyName,
          ownerContactEmail: l.ownerContactEmail,
          numberOfDevices: l.numberOfDevices,
          iPodCount: l.iPodCount,
          iPadCount: l.iPadCount,
          modules: l.modules,
          modulesString: this.getModulesString(l.modules),
          version: l.version,
          validUntil: l.validUntil,
          issuedBy: l.issuedBy,
          issuedAt: l.issuedAt,
          updatedAt: l.updatedAt,
          licenseStatus,
        };
      });
      this.isLoading = false;

      return response;
    },
    async exportLicense(licenseId) {
      await this.licenseService.exportLicense(licenseId);
    },
    updateLicense(license) {
      this.setSelectedLicense(license);
      this.$router.push({ name: 'edit-license', params: { id: license.id } });
    },
    async confirmLicenseRemoval(license) {
      const h = this.$createElement;
      const messageVNode = h('div', [
        h('p', [
          h('b-img', {
            class: ['warning-icon'],
            props: {
              src: warningIcon
            }
          })
        ]),
        h('p', [h('strong', 'Möchten Sie wirklich die Lizenz löschen?')]),
        h('p', [h('span', license.ownerCompanyName)])
      ]);
      const isConfirmed = await this.$bvModal.msgBoxConfirm([messageVNode], {
        centered: true,
        okTitle: 'Löschen',
        cancelTitle: 'Zurück',
        cancelVariant: 'outline-primary',
        modalClass: 'confirm-modal'
      });
      if (isConfirmed) {
        await this.licenseService.removeLicense(license.id);
        return true;
        // this.$refs.table.refresh();
      }
    },
    getModulesString(modules) {
      return modules.map(moduleName => moduleName).join(', ');
    }
  }
};
</script>

<style scoped lang="scss"></style>
